import { render } from "./ProjectsView.vue?vue&type=template&id=556aa5f2&scoped=true"
import script from "./ProjectsView.vue?vue&type=script&scoped=true&lang=js"
export * from "./ProjectsView.vue?vue&type=script&scoped=true&lang=js"

import "./ProjectsView.vue?vue&type=style&index=0&id=556aa5f2&scoped=true&lang=css"

import exportComponent from "C:\\Source\\LETC\\LETC_VueRouterWeb\\letc_vr_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556aa5f2"]])

export default __exports__